import { render, staticRenderFns } from "./classify12.vue?vue&type=template&id=5ecc2cae"
import script from "./classify12.vue?vue&type=script&lang=js"
export * from "./classify12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports